import { render } from "./ResetUserData.vue?vue&type=template&id=8a56ba88&scoped=true"
import script from "./ResetUserData.vue?vue&type=script&lang=js"
export * from "./ResetUserData.vue?vue&type=script&lang=js"

import "./ResetUserData.vue?vue&type=style&index=0&id=8a56ba88&scoped=true&lang=scss"

import exportComponent from "/var/lib/jenkins/workspace/acs-ui-builder@2/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8a56ba88"]])

export default __exports__